import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import MenuSetContactName from '../../../components/Contact/ContactDetails/MenuSetContactName/MenuSetContactName';
import MenuSetContactStatus from '../../../components/Contact/ContactDetails/MenuSetContactStatus/MenuSetContactStatus';
import MenuSetContactType from '../../../components/Contact/ContactDetails/MenuSetContactType/MenuSetContactType';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { ContactDisplayLayout } from '../../../sic-lib/enums/ContactDisplayLayout';
import { Contact } from '../../../sic-lib/types/Contact';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: '100%',
        [theme.breakpoints.down('lg')]: {
            position: 'relative',
        },
    },
    headingWrapper: {
        flexBasis: '56px',
        display: 'flex',
        alignItems: 'center',
    },
    statusWrapper: {
        flexBasis: '46px',
        display: 'flex',
        alignItems: 'center',
    },
    buttonWrapper: {
        position: 'absolute',
        top: '4px',
        left: 0,
        zIndex: 100,
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
}));

interface Props {
    cdDispatch: React.Dispatch<{ view: ContactDisplayLayout }>;
    contact: Contact;
}

export default function AsideHeader({ cdDispatch, contact }: Props) {
    const { classes } = useStyles();

    const handleNavigateBack = () => {
        cdDispatch({ view: ContactDisplayLayout.main });
    };

    return (
        <Grid
            container
            direction="column"
            wrap="nowrap"
            justifyContent="center"
            alignItems="center"
            className={classes.root}
        >
            <Grid item xs="auto" className={classes.buttonWrapper}>
                <Tooltip title="Messages">
                    <IconButton onClick={handleNavigateBack} size="large">
                        <ArrowBackIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item xs="auto" className={classes.headingWrapper}>
                <MenuSetContactName contact={contact} />
            </Grid>
            <Grid item xs="auto" className={classes.statusWrapper}>
                <MenuSetContactStatus contact={contact} />
            </Grid>
            <Grid item xs="auto" className={classes.statusWrapper}>
                <MenuSetContactType contact={contact} />
            </Grid>
        </Grid>
    );
}
